import { conversionTitle } from '@entities/Product/module/helper/conversionValue/conversionValue';
import { conversionValue } from '../../../../module/helper/conversionValue';
import { isModal } from '../../../../module/helper/isModal';
import { ProductSpecInfoModal } from '../../Modals/ProductSpecInfoModal';
import { ProductSpecTypeProps } from '../../ShortProductSpecs/ProductSpec/TypeProps';

import { ProductSpecCode, TornEnum } from '@app/entities/Product/module/types/productSchema';
import { SeasonEnum } from '@app/enums/SeasonEnum';
import { LinkColors, LinkTheme, MyLink, SkeletonLoading } from '@app/shared';
import { IconSpikes, IconSummer, IconWinter } from '@koleso-icons';

import styles from './ProductSpec.module.scss';
import classNames from 'classnames';

export const ProductSpec = ({ title, value, code, part, href, loading, transcript, isTranscript }: ProductSpecTypeProps) => {
  return (
    <div
      itemScope
      itemProp="additionalProperty"
      itemType="https://schema.org/PropertyValue"
      className={classNames(styles.ProductSpecWrapper, { [styles.BigText]: code === ProductSpecCode.OilLimit })}
      key={title}
    >
      <div className={styles.ProductSpecsTitle}>
        <span itemProp="name">{conversionTitle(code)}:</span>
        {isModal(part, code) && <ProductSpecInfoModal type={code} />}
      </div>
      <ProductSpec.Value href={href} code={code} value={value} loading={loading} isTranscript={isTranscript} transcript={transcript} />
    </div>
  );
};

ProductSpec.Value = function ProductSpecValue({
  code,
  value,
  href,
  isTranscript,
  transcript,
  loading,
}: Pick<ProductSpecTypeProps, 'code' | 'value' | 'isTranscript' | 'transcript' | 'href' | 'loading'>) {
  if (loading) {
    return (
      <div className={styles.ProductSpecsValue}>
        <SkeletonLoading width={'150px'} height={'18px'} />
      </div>
    );
  }

  if (href) {
    return (
      <div className={styles.ProductSpecsValue}>
        <ProductSpec.ValueIcon code={code} value={value} />
        <span itemProp="value">
          <MyLink href={href} themes={LinkTheme.Theme1} color={LinkColors.DarkViolet}>
            {conversionValue(code, value)} {isTranscript ? transcript : ''}
          </MyLink>
        </span>
      </div>
    );
  }

  return (
    <div className={styles.ProductSpecsValue}>
      <ProductSpec.ValueIcon code={code} value={value} />
      <span itemProp="value">
        {conversionValue(code, value)} {isTranscript ? transcript : ''}
      </span>
    </div>
  );
};

ProductSpec.ValueIcon = function ProductSpecValue({ code, value }: Pick<ProductSpecTypeProps, 'code' | 'value'>) {
  if (code === ProductSpecCode.Season) {
    return Number(value) === SeasonEnum.summer ? <IconSummer width={18} height={18} /> : <IconWinter width={18} height={18} />;
  }
  if (code === ProductSpecCode.Spikes && Number(value) === TornEnum.Torn) {
    return <IconSpikes width={18} height={18} />;
  }
  return null;
};
